import { PluginHook } from "mirador/dist/es/src/components/PluginHook";
import React from "react";
var DownloadDialogPluginArea = function DownloadDialogPluginArea(props) {
  return /*#__PURE__*/React.createElement(PluginHook, props);
}; // eslint-disable-line react/jsx-props-no-spreading

export default DownloadDialogPluginArea;